import { REDESIGN_ASSETS_BASE } from 'constants/redesign'

export const REDESIGN_ASSETS = REDESIGN_ASSETS_BASE
